import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KuiInputDirective } from './input.directive';

@NgModule({
  imports: [CommonModule],
  exports: [KuiInputDirective],
  declarations: [KuiInputDirective],
})
export class KuiInputModule {}
